import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;
  min-width: 0;
`;

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;
  min-width: 0;
`;

export const AddGuestRow = styled.div`
  display: flex;
  margin-bottom: ${space['space-400']};
`;
